// Presentation formatters shared by more than one feature.
// TSS vite/01 — pure helpers reused across features belong in core/, not in
// whichever feature happened to need them first.

const CURRENCY = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0,
});

const TIME = new Intl.DateTimeFormat('es-CO', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
});

const DATE_TIME = new Intl.DateTimeFormat('es-CO', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
});

export function formatCurrency(value) {
    return CURRENCY.format(value);
}

export function formatTime(timestamp) {
    return TIME.format(timestamp);
}

export function formatDateTime(timestamp) {
    return DATE_TIME.format(timestamp);
}

// mm:ss for a countdown that never exceeds the draw interval.
export function formatCountdown(milliseconds) {
    const totalSeconds = Math.max(0, Math.ceil(milliseconds / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function formatCount(value) {
    return new Intl.NumberFormat('es-CO').format(value);
}
